// extracted by mini-css-extract-plugin
export var extraBottomMargin = "PMB79";
export var icon = "sjJzQ";
export var root = "lwCJ0";
export var show = "bgwIu";
export var text = "XaRej";